import React from 'react';
import {
  Box
} from '@material-ui/core';

export default props =>
  <Box {...props}>
    <img style={{width: '100%', display: 'block'}} src={props.src} alt=''/>
  </Box>
